export default __webpack_public_path__ + "static/Perroquet-poster-1e2c6aefe80a23a3d294f26ee0b832b9.jpg";